"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class SchoolNotFoundError extends client_library_1.ExtendableError {
    constructor() {
        super('Requested school not found');
    }
}
exports.default = SchoolNotFoundError;
//# sourceMappingURL=SchoolNotFoundError.js.map